import { datadogRum } from "@datadog/browser-rum";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import renderValue from "../elements/dropdown-placeholder";

import {
  Container,
  Box,
  Button,
} from "@/components/onboardingSections/container";
import {
  CustomSelect,
  MoneyInput,
  StyledOption,
} from "@/components/onboardingSections/inputs";
import styles from "@/styles/onboarding.module.scss";

export default function Expenses({
  expensesData,
  expensesComplete,
  expensesAltButton,
  personalData,
  addressData,
}) {
  const router = useRouter();
  const [contract, setContract] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [expensesArray, setExpenesArray] = useState(expensesData);

  function parentArray(e, arrayKey) {
    expensesArray[arrayKey] = e;
    setExpenesArray(old => {
      return {
        ...old,
      };
    });
  }

  useEffect(() => {
    if (
      contract !== null &&
      expensesArray.employment !== "" &&
      expensesArray.nett_monthly_income !== "" &&
      expensesArray.other_cost !== "" &&
      expensesArray.monthly_credit_commitments !== "" &&
      expensesArray.monthly_housing_costs !== "" &&
      expensesArray.pay_frequency !== ""
    ) {
      datadogRum.addAction("3.2-Income-success", {
        onboardingChannel: "Organic",
      });
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [contract, expensesArray]);

  const onSubmit = e => {
    setLoading(true);
    e.preventDefault();
    if (
      contract === 20 ||
      expensesArray.employment === "Self Employed" ||
      expensesArray.employment === "Retired" ||
      expensesArray.employment === "Not Employed"
    ) {
      const query = JSON.stringify({
        mobile_phone: personalData.mobileNumbers,
        email_address: personalData.emailAddresses,
        salutation: personalData.title,
        first_name: personalData.firstName,
        last_name: personalData.lastName,
        birth_date: personalData.dateOfBirth,
        postcode: addressData.postcode,
        street: addressData.street,
        town_or_city: addressData.town,
        buildingNumber: addressData.buildingNumber,
        buildingName: addressData.buildingName,
      });
      router.push(
        `/credit-card/declined?data=${query}`,
        "/credit-card/declined?nd=y",
      );
    } else {
      datadogRum.addAction("3.3-Income-submitted", {
        onboardingChannel: "Organic",
      });
      expensesComplete(true, expensesArray);
      setLoading(false);
      // router.push(`/partner/bank-details?employment=${base64url(employment)}&takehome=${takeHome}&expenses=${monthlyExpenes}&credit=${credit}&rent=${rent}`, '/partner/bank-details')
    }
  };

  return (
    <Container onSubmit={onSubmit}>
      <p className={styles.topTitle}>Please confirm your income and expenses</p>
      <Box gap={7} hideBoxMobile>
        <div className="flex flex-col gap-2.5">
          <label htmlFor="empStatus" className={styles.inputTitle}>
            Employment status
          </label>
          <div className="relative w-full">
            <CustomSelect
              id="empStatus"
              value={expensesArray.employment}
              onChange={e => parentArray(e, "employment")}
              renderValue={renderValue}
            >
              <StyledOption value="Employed Full Time">Full time</StyledOption>
              <StyledOption value="Employed Part Time">Part time</StyledOption>
              <StyledOption value="Self Employed">Self employed</StyledOption>
              <StyledOption value="Not Employed">Not Employed</StyledOption>
              <StyledOption value="Retired">Retired</StyledOption>
            </CustomSelect>
          </div>
        </div>
        <div className="flex flex-col gap-2.5">
          <label htmlFor="zeroHoursQuestion" className={styles.inputTitle}>
            Are you employed on a zero hours contract?
          </label>
          <div className="relative w-full">
            <CustomSelect
              id="zeroHoursQuestion"
              value={contract}
              onChange={setContract}
              renderValue={renderValue}
            >
              <StyledOption value={10}>No</StyledOption>
              <StyledOption value={20}>Yes</StyledOption>
            </CustomSelect>
          </div>
        </div>
        <div className="flex flex-col gap-2.5">
          <label htmlFor="payFrequency" className={styles.inputTitle}>
            Pay frequency
          </label>
          <div className="relative w-full">
            <CustomSelect
              id="payFrequency"
              value={expensesArray.pay_frequency}
              onChange={e => parentArray(e, "pay_frequency")}
              renderValue={renderValue}
            >
              <StyledOption value="Monthly">Monthly</StyledOption>
              <StyledOption value="Weekly">Weekly</StyledOption>
              <StyledOption value="Fortnightly">Every two weeks</StyledOption>
              <StyledOption value="Four-Weekly">Every four weeks</StyledOption>
            </CustomSelect>
          </div>
        </div>
        <MoneyInput
          value={expensesArray.nett_monthly_income}
          id="nett_monthly_income"
          onChange={v => parentArray(v.floatValue, "nett_monthly_income")}
          label="Monthly take-home pay (after tax)"
        />
        <MoneyInput
          value={expensesArray.monthly_housing_costs}
          id="monthly_housing_costs"
          onChange={v => parentArray(v.floatValue, "monthly_housing_costs")}
          label="Monthly rent or mortgage payment"
        />
        <MoneyInput
          value={expensesArray.monthly_credit_commitments}
          id="monthly_credit_commitments"
          onChange={v =>
            parentArray(v.floatValue, "monthly_credit_commitments")
          }
          label="Monthly credit card or loan repayments"
        />
        <MoneyInput
          value={expensesArray.other_cost}
          id="other_cost"
          help="These include things like transport, food, utility bills and entertainment."
          onChange={v => parentArray(v.floatValue, "other_cost")}
          label="Other essential expenses"
        />
        <Button disabled={disabled} loading={loading}>
          {expensesAltButton ? "Update details" : "Next step"}
        </Button>
      </Box>
    </Container>
  );
}
